import { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme, responsiveFontSizes } from "@mui/material/styles";
import { Route, Routes, Navigate } from "react-router-dom";
import Footer from "./common/Footer";
import Header from "./Header";
import DynamicPage from "./common/DynamicPage";
import Reroute from "./common/Redirect";
import ResponsiveDrawer from "./common/component/ResponsiveDrawer";
import { THEME } from "./common/constants";
import ContextProvider from "./context/UserContext";
import BookDemo from "./baker/screen/BookDemo";
import SaaSHome from "./baker/screen/Home";
import { getDataFromLocalStorage, setDataInLocalStorage, getQueryParam } from "./common/util";

let theme = createTheme(THEME);
theme = responsiveFontSizes(theme);

export default function App(props) {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const utms = getQueryParam(window.location.search, "utm_source");
  if (utms) {
    const utmm = getQueryParam(window.location.search, "utm_medium");
    const utmc = getQueryParam(window.location.search, "utm_campaign");

    setDataInLocalStorage("utm", { utms, utmm, utmc });
    console.log("utm", { utms, utmm, utmc });
    window.history.replaceState(null, "", window.location.pathname);
  } else {
    var referrer = document.referrer;
    if (referrer) {
      var a = document.createElement("a");
      a.href = referrer;

      const utm = getDataFromLocalStorage("utm", 30 * 24 * 60 * 60 * 1000);
      if (!utm) {
        setDataInLocalStorage("utm", { utms: a.hostname, utmm: "", utmc: "" });
      }
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ContextProvider>
        <div style={{ display: "flex" }}>
          <ResponsiveDrawer open={mobileDrawerOpen} toggle={() => setMobileDrawerOpen(!mobileDrawerOpen)} />
          <main style={{ flexGrow: "1" }}>
            <Header toggleMobileDrawer={() => setMobileDrawerOpen(!mobileDrawerOpen)} />
            <Routes>
              <Route path="/book-demo" element={<BookDemo />} />
              <Route path="/privacy-policy" element={<DynamicPage {...props} handle="privacy-policy" />} />
              <Route path="/terms-of-service" element={<DynamicPage {...props} handle="terms-of-service" />} />
              <Route path="/to/:cat/:id" element={<Reroute />} />
              <Route path="/saas" element={<SaaSHome />} />
              <Route path="/" element={<SaaSHome />} />
              <Route path="*" element={<Navigate replace to="/" />} />
            </Routes>
            <Footer />
          </main>
        </div>
      </ContextProvider>
    </ThemeProvider>
  );
}
